/**
 * 数字格式化
 * @param {*} count
 */
export const formatCount = function (value) {
    if (value <= 0) return 0;
    if (value < 10000) return value;
    if (value < 100000) return `${(value / 10000).toFixed(1)}万`;
    if (value < 100000000) return `${(value / 10000).toFixed(0)}万`;
    return `${(value / 100000000).toFixed(0)}亿`;
};
